import * as React from 'react';
import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { Numberbox } from 'ui';

export const decimalNumberCreator = (fieldData: SimpleFormComponentProps, fieldMethods: SimpleFormMethods) =>
  <Numberbox
    componentId={fieldData.name}
    className={fieldData.className}
    locale={fieldData.locale}
    placeholder={fieldData.placeholder}
    label={fieldMethods.buildLabel(fieldData.label)}
    value={fieldMethods.getProperty(fieldData.name)}
    onChange={fieldMethods.handleChange(fieldData.name)}    
    maxDecimals={fieldData.maxDecimals}
    maxValue={fieldData.maxValue}
    minValue={fieldData.minValue}
    readOnly={fieldData.readOnly}
    validation={fieldMethods.getValidation(fieldData.name)}
    textInvalidRangeError={fieldData.errorMessage}
  />;
